module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-layout', [_c('md-layout', {
    attrs: {
      "md-flex": "70"
    }
  }, [_c('md-toolbar', {
    staticClass: "md-transparent ql-project-header"
  }, [_c('div', {
    staticClass: "project-toggles"
  }, [_c('span', {
    staticClass: "dark-mode-toggle"
  }, [_c('md-switch', {
    attrs: {
      "id": "showMode",
      "name": "showMode"
    },
    on: {
      "change": _vm.toggleShowMode
    },
    model: {
      value: (_vm.localShowMode),
      callback: function($$v) {
        _vm.localShowMode = $$v
      },
      expression: "localShowMode"
    }
  }, [_vm._v("Dark Mode")])], 1), _vm._v(" "), (_vm.isOwner) ? _c('span', {
    staticClass: "project-lock-toggle"
  }, [_c('md-switch', {
    attrs: {
      "id": "locked",
      "name": "locked"
    },
    on: {
      "change": _vm.toggleLocked
    },
    model: {
      value: (_vm.localLocked),
      callback: function($$v) {
        _vm.localLocked = $$v
      },
      expression: "localLocked"
    }
  }, [_vm._v("Project Lock")])], 1) : _vm._e()]), _vm._v(" "), _c('project-pagination', {
    staticClass: "ql-project-header-pull-right",
    attrs: {
      "totalPages": _vm.totalPages,
      "currentPage": _vm.currentPage
    },
    on: {
      "pageUp": _vm.pageUp,
      "pageDown": _vm.pageDown,
      "setPage": _vm.setPage
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-toolbar', {
    staticClass: "md-transparent ql-project-header"
  }, [_c('span', {
    staticStyle: {
      "flex": "1"
    }
  }), _vm._v(" "), (_vm.isActivePay) ? _c('span', {
    staticClass: "ql-project-role"
  }, [_vm._v("Collaborator")]) : _c('span', {
    staticClass: "ql-project-role"
  }, [_vm._v("Observer")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-500c2a73","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sample/components/project/header.vue
// module id = 651
// module chunks = 2